import { render, staticRenderFns } from "./SearchResource.vue?vue&type=template&id=626d0072&scoped=true"
import script from "./SearchResource.vue?vue&type=script&lang=js"
export * from "./SearchResource.vue?vue&type=script&lang=js"
import style0 from "./SearchResource.vue?vue&type=style&index=0&id=626d0072&prod&lang=less&scoped=true"
import style1 from "./SearchResource.vue?vue&type=style&index=1&id=626d0072&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626d0072",
  null
  
)

export default component.exports